import Ad from 'src/components/ads/Ad';
import MovieChartItem from 'src/components/kinotoppen/MovieChartItem';
import { MovieChart } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type ShowMovieChartProps = {
	showAllMovies: boolean;
	movieChart?: MovieChart | null;
	children: React.ReactNode;
};
//#endregion

//#region [Component]
export default function ShowMovieChart({ showAllMovies, movieChart, children }: ShowMovieChartProps) {
	const maxMovies = showAllMovies ? 1000 : 10;

	return <div>
		<SChartItems>
			{(movieChart?.movieChartItem?.length ?? 0) > 0 && <>
				{movieChart!.movieChartItem!
					.filter(ci => !!ci?.movie)
					.slice(0, 5)
					.map(ci => <MovieChartItem key={ci!.movie!.mainVersionId} chartItem={ci!} />)}
			</>}
			{/** children must always be rendered, otherwise the ad will vanish after user interaction*/}
			{children}

			{(movieChart?.movieChartItem?.length ?? 0) > 0 && <>
				{movieChart!.movieChartItem!
					.filter(ci => !!ci?.movie)
					.slice(5, maxMovies)
					.map(ci => <MovieChartItem key={ci!.movie!.mainVersionId} chartItem={ci!} />)}
			</>}
		</SChartItems>
	</div >;
}
//#endregion

//#region [Styles]

const SChartItems = styled.div`
	display: flex;
	gap: 20px;
	flex-direction: column;
	min-height: 100vh;
`;


//#endregion